import React from 'react';
import {Helmet} from 'react-helmet';
import _ from 'lodash';

import {safePrefix} from '../utils';
import Header from './Header';
import Footer from './Footer';

export default class Body extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>{_.get(this.props, 'pageContext.frontmatter.title') && _.get(this.props, 'pageContext.frontmatter.title') + ' - '}{_.get(this.props, 'pageContext.site.siteMetadata.title')}</title>
                    <meta charSet="utf-8" />
                    <meta name="viewport" content="width=device-width, initialScale=1.0" />
                    <meta name="description" content={_.get(this.props, 'pageContext.frontmatter.excerpt') || _.get(this.props, 'pageContext.site.siteMetadata.description')} />
                    <link href="https://fonts.googleapis.com/css?family=Roboto:400,400i,700,700i&display=swap" rel="stylesheet" /> 
                    <link rel="stylesheet" href={safePrefix('assets/css/main.css')} />
                    <link rel="apple-touch-icon" sizes="180x180" href={safePrefix("images/favicon/apple-touch-icon.png")} />
                    <link rel="icon" type="image/png" sizes="32x32" href={safePrefix("images/favicon/favicon-32x32.png")} />
                    <link rel="icon" type="image/png" sizes="16x16" href={safePrefix("images/favicon/favicon-16x16.png")} />
                    <link rel="manifest" href={safePrefix("site.webmanifest")} />
                    <link rel="shortcut icon" href={safePrefix("images/favicon/favicon.ico")} />
                    <meta name="msapplication-TileColor" content="#039DE7" />
                    <meta name="msapplication-config" content="browserconfig.xml" />
                    <meta name="theme-color" content="#039DE7" />
                    {(_.get(this.props, 'pageContext.frontmatter.template') === 'post') &&  
                    _.get(this.props, 'pageContext.frontmatter.canonical_url') && 
                    <link rel="canonical" href={_.get(this.props, 'pageContext.frontmatter.canonical_url')} />
                    }
                </Helmet>
                <div id="page" className={'site style-' + _.get(this.props, 'pageContext.site.siteMetadata.layout_style') + ' palette-' + _.get(this.props, 'pageContext.site.siteMetadata.palette')}>
                  <Header {...this.props} />
                  <div id="content" className="site-content">
                    <div className="inner">
                      <main id="main" className="site-main">
                        {this.props.children}
                      </main>
                      <Footer {...this.props} />
                    </div>
                  </div>
                </div>
            </React.Fragment>
        );
    }
}
